// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QpuZ","toggleWrap":"styles_toggleWrap__pBni7","content":"styles_content__D1V-B","selectAreaCode":"styles_selectAreaCode__2pfDx"};